<template>
    <v-dialog v-model="mostra" max-width="480">
        <v-card>
            <v-card-title>
                Deseja Excluir {{ servico.titulo }}?
            </v-card-title>
            <v-card-text>
                Essa ação é irreversível...
            </v-card-text>
            <v-card-actions>
                <v-btn
                    text
                    color="error"
                    @click="() => mutate(servico._id)"
                    :loading="excluindo"
                    :disabled="excluindo"
                > Sim </v-btn>
                <v-btn
                    text
                    color="grey"
                    class="ml-auto"
                    :disabled="excluindo"
                    @click="() => mostra = false"
                > Não </v-btn>
            </v-card-actions>
        </v-card>
        <template
            v-for="(_, name) in $scopedSlots"
            #[name]="slotProps = {}"
        >
            <slot
                v-bind="slotProps"
                :name="name"
            />
        </template>
    </v-dialog>
</template>

<script setup lang="ts">
import ServicoService from '@/services/ServicoService';
import { useMutation, useQueryClient } from '@tanstack/vue-query';
import { Servico } from 'common/types/Servico';
import { ref } from 'vue';

defineProps<{ servico: Servico }>()

const client = useQueryClient()

const mostra = ref(false)

const { mutate, isPending: excluindo } = useMutation({
	mutationFn: (id: string) => ServicoService.remove(id),
	onSuccess(_data, id) {
		mostra.value = false
        client.invalidateQueries({ queryKey: ['servicos'], exact: false })
	},
})
</script>